import { useState, useEffect } from "react";
import { isMobile as isReactDeviceDetectMobile } from "react-device-detect";

/**
 * Custom hook to detect mobile devices with enhanced detection for larger phones
 * Combines screen width, touch capability, and user agent detection
 */
export const useDeviceDetection = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);

  useEffect(() => {
    const checkMobileDevice = () => {
      // Method 1: Check screen width (includes larger phones like iPhone 17 Pro Max)
      const screenWidth = window.innerWidth;
      const isMobileWidth = screenWidth <= 1024; // Tablets and phones

      // Method 2: Check for touch capability
      const hasTouchScreen = 
        'ontouchstart' in window || 
        navigator.maxTouchPoints > 0 || 
        navigator.msMaxTouchPoints > 0;

      // Method 3: User agent check (fallback)
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isMobileUserAgent = 
        /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini|mobile|tablet/i.test(userAgent.toLowerCase());

      // Method 4: Use react-device-detect as additional input
      const isReactMobile = isReactDeviceDetectMobile;

      // Combine checks: If any strong mobile indicator is present
      const isMobile = 
        (isMobileWidth && hasTouchScreen) || 
        (isMobileUserAgent && isMobileWidth) ||
        (isReactMobile && isMobileWidth);

      setIsMobileDevice(isMobile);
    };

    // Initial check
    checkMobileDevice();

    // Add resize listener to handle orientation changes and responsive behavior
    window.addEventListener('resize', checkMobileDevice);
    window.addEventListener('orientationchange', checkMobileDevice);

    // Cleanup listeners
    return () => {
      window.removeEventListener('resize', checkMobileDevice);
      window.removeEventListener('orientationchange', checkMobileDevice);
    };
  }, []);

  return isMobileDevice;
};
